export class User {
	id: number;
	name: string;
	surname: string;
	username: string;
	email: string;
	companyName?: string;
	phoneNumber?: string;
	birthDate?: string;
	gender?: string;
	fiscalCode?: string;
	disabled: boolean;
	emailVerifiedAt: string;
	subscription?: {
		type: {
			slug: string;
			stripePriceId: string;
			name: string;
			description: string;
			price: number;
			currency: string;
			tier: number;
			durationMonths: number;
			id: number;
			maxMembers: number;
		};
		createdAt: string;
		id: number;
		expiresAt: string;
		isActive: boolean;
		isOwner: boolean,
		automaticRenewal: boolean,
		trialEligible: boolean,
		paymentStatus: string,
		paymentPlatform: string,
		currentPeriodStart: string,
	} | null;
	stripeCustomerId?: string;
	languageCode?: string;

	constructor(data: any) {
		this.id = data.id ?? null;
		this.name = data.name ?? null;
		this.surname = data.surname ?? null;
		this.username = data.username ?? null;
		this.email = data.email ?? null;
		this.companyName = data.company_name ?? null;
		this.phoneNumber = data.phone_number ?? null;
		this.birthDate = data.birth_date ?? null;
		this.gender = ['M', 'F', 'O'].includes(data.gender) ? data.gender : null;
		this.fiscalCode = data.fiscal_code ?? null;
		this.disabled = data.disabled ?? false;
		this.emailVerifiedAt = data.email_verified_at ?? null;
		this.subscription = data.subscription
			? {
				type: {
					slug: data.subscription.type?.slug ?? null,
					stripePriceId: data.subscription.type?.stripe_price_id ?? null,
					name: data.subscription.type?.name ?? null,
					description: data.subscription.type?.description ?? null,
					price: data.subscription.type?.price ?? 0,
					currency: data.subscription.type?.currency ?? null,
					tier: data.subscription.type?.tier ?? 0,
					durationMonths: data.subscription.type?.duration_months ?? 0,
					id: data.subscription.type?.id ?? null,
					maxMembers: data.subscription.type?.max_members ?? 1,
				},
				createdAt: data.subscription.created_at ?? null,
				id: data.subscription.id ?? null,
				automaticRenewal: data.subscription.automatic_renewal ?? false,
				expiresAt: data.subscription.expires_at ?? null,
				isActive: data.subscription.is_active ?? false,
				isOwner: data.subscription.role === 'owner',
				trialEligible: data.subscription.trial_eligible ?? false,
				paymentStatus: data.subscription.payment_status ?? null,
				paymentPlatform: data.subscription.payment_platform ?? null,
				currentPeriodStart: data.subscription.current_period_start ?? null,
			}
			: null;
		this.stripeCustomerId = data.stripe_customer_id ?? null;
		this.languageCode = data.language_code ?? null;
	}
}